module.exports = __webpack_public_path__ + "img/こんな方-03.33f24d6d.png";